export default __webpack_public_path__ + "static/media/cimb-icon.9052a7b4.svg";